<template>
  <el-dialog
    :title="passwordDialogObj.force ? '您的密码已逾期' : '修改密码'"
    :visible="passwordDialogObj.visible"
    width="520px"
    center
    :show-close="false"
    :close-on-click-modal="false"
  >
    <div
      v-if="passwordDialogObj.force"
      style="
        margin-bottom: 20px;
        color: #f56c6c;
        font-weight: 600;
        text-align: center;
      "
    >
      您的密码已逾期！请先设置您的新密码以便继续
    </div>

    <el-form :rules="rules" :model="editData" ref="form" label-width="95px">
      <el-form-item label="旧密码">
        <el-input
          id="OriginPassword"
          name="OriginPassword"
          size="small"
          style="width: 230px"
          :type="!showOldPassword ? 'password' : ''"
          v-model="editData.oldPassword"
        >
          <span
            slot="suffix"
            class="cursorPointer"
            @click="showOldPassword = !showOldPassword"
          >
            <svg-icon
              :icon-class="!showOldPassword ? 'eye' : 'eye-open'"
              class="color-main"
            ></svg-icon>
          </span>
        </el-input>
      </el-form-item>
      <el-form-item label="用户" v-show="false">
        <el-input
          id="username"
          name="username"
          size="small"
          style="width: 230px"
          type="text"
          :disabled="true"
          :value="userInfo.username"
        >
        </el-input>
      </el-form-item>
      <el-form-item prop="newPassword" label="新密码">
        <el-input
          id="password"
          name="password"
          size="small"
          style="width: 230px"
          :type="!showNewPassword ? 'password' : ''"
          v-model="editData.newPassword"
        >
          <span
            slot="suffix"
            class="cursorPointer"
            @click="showNewPassword = !showNewPassword"
          >
            <svg-icon
              :icon-class="!showNewPassword ? 'eye' : 'eye-open'"
              class="color-main"
            ></svg-icon>
          </span>
        </el-input>
        <el-button
          size="small"
          @click="
            const password = generateRandomPassword();
            editData.newPassword = password;
            confirmNewPassword = password;
          "
          >随机生成</el-button
        ><el-button
          :disabled="!editData.newPassword"
          size="small"
          icon="el-icon-document-copy"
          @click="
            CopyTextToClipboard(
              editData.newPassword,
              '已复制密码至剪贴板，请谨慎管理您的密码！'
            )
          "
        ></el-button>
      </el-form-item>
      <el-form-item label="确认新密码">
        <el-input
          id="showNewPassword"
          name="showNewPassword"
          size="small"
          style="width: 230px"
          :type="!showConfirmNewPassword ? 'password' : ''"
          v-model="confirmNewPassword"
        >
          <span
            slot="suffix"
            class="cursorPointer"
            @click="showConfirmNewPassword = !showConfirmNewPassword"
          >
            <svg-icon
              :icon-class="!showConfirmNewPassword ? 'eye' : 'eye-open'"
              class="color-main"
            ></svg-icon>
          </span>
        </el-input>
      </el-form-item>
      <el-form-item prop="captcha">
        <el-input
          id="captcha"
          name="captcha"
          size="small"
          style="width: 230px"
          v-model="editData.captcha"
          placeholder="请输入谷歌验证码"
        />
      </el-form-item>
    </el-form>

    <span slot="footer" class="dialog-footer">
      <el-button v-if="!passwordDialogObj.force" round @click="handleCancel()">
        取消
      </el-button>
      <el-button v-else round @click="logout()" type="warning">
        登出
      </el-button>
      <el-button
        :loading="submitLoading"
        round
        type="success"
        @click="handleSubmit()"
      >
        保存
      </el-button>
    </span>
  </el-dialog>
</template>

<script>
import mainCommon from "@/utils/mainCommon";
import { updatePassword } from "@/api/user";

export default {
  props: ["passwordDialogObj"],
  mixins: [mainCommon],
  data() {
    return {
      showOldPassword: false,
      showNewPassword: false,
      showConfirmNewPassword: false,
      confirmNewPassword: null, // 确认新密码
      editData: {
        oldPassword: null,
        newPassword: null,
        captcha: null,
      },
      rules: {
        captcha: [{ required: true, message: "必填项目不可为空" }],
        newPassword: [
          {
            required: true,
            message: "需包含英文大小写、特殊字元及数字，长度不可少于 10 位",
            pattern:
              /^(?=.*\d)(?=.*[a-z])(?=.*[A-Z])(?=.*[!@#$%^&*()_+\-=[\]{};':"\\|,.<>/?]).{10,}$/,
          },
        ],
      },
      submitLoading: false,
    };
  },
  methods: {
    handleSubmit() {
      if (!/[a-z]/.test(this.editData.newPassword)) {
        return this.$notify.error("新密码缺少英文小写");
      }
      if (!/[A-Z]/.test(this.editData.newPassword)) {
        return this.$notify.error("新密码缺少英文大写");
      }
      if (!/\d/.test(this.editData.newPassword)) {
        return this.$notify.error("新密码缺少数字");
      }
      if (
        !/[!@#$%^&*()_+\-=[\]{};':"\\|,.<>/?]/.test(this.editData.newPassword)
      ) {
        return this.$notify.error("新密码缺少特殊符号");
      }
      if (this.confirmNewPassword !== this.editData.newPassword) {
        return this.$notify.error("新密码与确认新密码不同");
      }

      this.$refs.form.validate((valid) => {
        if (!valid) return;

        this.submitLoading = true;
        this.editData.username = this.userInfo.username;

        this.showOldPassword = false;
        this.showNewPassword = false;
        this.showConfirmNewPassword = false;

        updatePassword(this.editData)
          .then((res) => {
            this.$notify.success(res.message);

            // 修改成功后强制登出
            this.$store.dispatch("LogOut").then(() => {
              location.reload();
            });
          })
          .finally(() => {
            this.submitLoading = false;
          });
      });
    },
    handleCancel() {
      this.showOldPassword = false;
      this.showNewPassword = false;
      this.showConfirmNewPassword = false;
      this.editData = {
        oldPassword: null,
        newPassword: null,
        captcha: null,
      };
      this.confirmNewPassword = null;
      this.$refs.form.resetFields();
      this.$emit("update:password-dialog-obj", {});
    },
    // 登出
    logout() {
      this.$store.dispatch("LogOut").then(() => {
        location.reload();
      });
    },
  },
};
</script>

<style lang="scss" scoped>
.text-red {
  color: #f56c6c;
  font-weight: 600;
}
.text-yellow {
  color: #e6a23c;
  font-weight: 600;
}
.text-green {
  color: #67c23a;
  font-weight: 600;
}
</style>


// WEBPACK FOOTER //
// src/views/profile/my/PasswordDialog.vue